module.exports = __webpack_public_path__ + "static/logo-1780964376a90125341ecde28fa172dd.png";